import styled from "styled-components";

export const StyledChatInput = styled.div`
  position: relative;
  padding: var(--spacing-sm) var(--spacing-md);
  input {
    width: 100%;
    height: 50px;
    border: 1px solid var(--color-text-20);
    padding-left: var(--spacing-md);
    border-radius: 50px;
    padding-right: 56px;
  }
  button {
    position: absolute;
    right: var(--spacing-md);
    padding: 0 var(--spacing-md);
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }
`;
